module.exports = __webpack_public_path__ + "img/revel-x-como.cb45a45d.svg";